import { FormApi } from 'final-form'
import arrayMutators from 'final-form-arrays'
import createDecorator from 'final-form-focus'
import { isFunction, noop } from 'lodash'
import React, { useState } from 'react'
import { Form as FinalForm } from 'react-final-form'
import { RouteComponentProps } from 'react-router'
import { toast } from 'react-toastify'
import styled from 'styled-components'

import { request } from '../../utils'
import { parseCronConfig } from '../CronConfigurator'
import Dialog from '../Dialog'
import Form, { stringifyValues } from './Form'

const Wrapper = styled.div``
const focusOnErrors = createDecorator()

interface TCronEditor extends RouteComponentProps {
  order?: any
  values?: any
  setLoading?: (val: boolean) => void
  buttonElement?:
    | React.ReactElement
    | ((opts: { onClick: () => void }) => React.ReactElement)
  redirectUrl?: string
  applyFilter?: () => void
  spanClass?: string
}

const CronEditor = (props: TCronEditor): React.ReactElement => {
  const {
    order,
    values = undefined,
    setLoading = noop,
    buttonElement = <></>,
    redirectUrl = undefined,
    applyFilter = noop,
    spanClass = '',
  } = props

  const [openDialog, setDialog] = useState(false)

  const [form, setForm] = useState<FormApi>()

  const onSubmit = async (formValues: any): Promise<void> => {
    setDialog(false)
    try {
      if (setLoading) {
        setLoading(true)
      }
      const submitValues = stringifyValues(formValues)
      const { data } = await request({
        method: values ? 'patch' : 'put',
        url: values ? `/api/cronorder/${values.id}` : `/api/cronorder`,
        data: values
          ? { ...submitValues }
          : {
              ...submitValues,
              order,
            },
      })

      values
        ? toast.success(
            i18n.t('success_edit_cron_order', 'Dauerauftrag aktualisiert'),
          )
        : toast.success(
            i18n.t('success_create_cron_order', 'Dauerauftrag erstellt'),
          )
    } catch (err) {
      toast.error(
        values
          ? i18n.t(
              'error_updating_cron_order',
              'Dauerauftrag konnte nicht aktualisiert werden',
            )
          : i18n.t(
              'error_creating_cron_order',
              'Dauerauftrag konnte nicht erstellt werden',
            ),
      )
      console.error(err)
    } finally {
      setLoading(false)

      if (redirectUrl) {
        props.history.push(redirectUrl)
      }

      applyFilter()
    }
  }

  return (
    <>
      <span className={`${spanClass}`}>
        {isFunction(buttonElement)
          ? buttonElement({ onClick: () => setDialog(true) })
          : React.cloneElement(buttonElement, {
              onClick: () => setDialog(true),
            })}

        <Dialog
          show={openDialog}
          onHide={() => setDialog(false)}
          size="lg"
          title={i18n.t('cron_editor_order', 'Dauerauftrag erstellen')}
        >
          <form
            onSubmit={(e) => e.preventDefault()}
            id="Form/form"
            noValidate
            className="needs-validation"
          >
            <FinalForm
              onSubmit={onSubmit}
              subscription={{
                initialValues: true,
                submitting: true,
                pristine: true,
              }}
              decorators={[focusOnErrors]}
              mutators={arrayMutators as any}
            >
              {(formProps) => (
                <Form
                  {...formProps}
                  getFormApi={setForm}
                  initialValues={values || { cronConfig: parseCronConfig() }}
                  setDialog={setDialog}
                />
              )}
            </FinalForm>
          </form>
        </Dialog>
      </span>
    </>
  )
}

export default CronEditor
